<div class="flex items-center justify-center gap-1 mx-auto my-8">
	@if (page !== 0) {
		<button
			(click)="prev()"
			[disabled]="page === 0"
			class="hover:bg-peps-yellow hover:text-peps-dark-700 cursor-pointer py-2.5 px-2.5"
		>
			<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
				<path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
			</svg>
		</button>
	}
	@for (p of pageNumbers(); track p) {
		@if (p !== -1) {
			<button
				(click)="changePage(p)"
				[ngClass]="{
          'bg-peps-gold text-peps-dark-700': page === p,
          'hover:bg-peps-yellow hover:text-peps-dark-700': page !== p
        }"
				class="py-2.5 px-4.5 cursor-pointer"
			>
				{{ p + 1 }}
			</button>
		} @else {
			<span class="px-2 py-1">...</span>
		}
	}
	@if (page + 1 < totalPages) {
		<button
			(click)="next()"
			[disabled]="page + 1 >= totalPages"
			class="hover:bg-peps-yellow hover:text-peps-dark-700 cursor-pointer py-2.5 px-2.5"
		>
			<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
				<path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
			</svg>
		</button>
	}
</div>
